import * as _ from 'lodash';
import * as moment from 'moment';
import * as qs from 'query-string';
import { Component, FormEvent } from 'react';
import { Dispatch, connect } from 'react-redux';
import { AppActionCreators, IApplicationState, ICheckForExistingAliasAndMrnResponse, IExistingMatch, INewDonorRecipientSaveResponse, INewDonorRecipientlookupDataResponse, NewDonorRecipientActionCreators, OrdersActionCreators } from '@nkr/store/index';
import { ICheekSwabRequest, IListItem, INewDonorRecipientBaseData, IRecipient } from '@nkr/models/index';
import { downloadFile } from '@nkr/services/download-file';
import { IBaseDataValidation, PatientSelection, TypeOption, initialDonorDetails, initialRecipientDetails, initialValidation, typeOptionList } from './data-model';
import { Alert, Button, Col, ControlLabel, Form, FormControl, FormGroup, Panel, Row, Table } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { ContainerWrapper } from './styles';
import DonorDetails from './donor-details';
import RecipientDetails from './recipient-details';

interface IProps {
    centerId: number
}

interface IStateProps { }

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getLookupData: (centerId: number) => Promise<INewDonorRecipientlookupDataResponse>,
    checkForExistingDonorAliasAndMrn: (centerId: number, alias: string, mrn: string) => Promise<ICheckForExistingAliasAndMrnResponse>,
    checkForExistingRecipientAliasAndMrn: (centerId: number, alias: string, mrn: string) => Promise<ICheckForExistingAliasAndMrnResponse>,
    saveNewDonorRecipient: (centerId: number, type: number, existingRecipientId: number, donorDetails: INewDonorRecipientBaseData, recipientDetails: INewDonorRecipientBaseData) => Promise<INewDonorRecipientSaveResponse>
    saveNewPairedDonor: (centerId: number, existingRecipientId: number, donorDetails: INewDonorRecipientBaseData) => Promise<INewDonorRecipientSaveResponse>
    createDonorOrder: (donorId: number, request: ICheekSwabRequest) => Promise<any>,
    createRecipientOrder: (recipientId: number, request: ICheekSwabRequest) => Promise<any>,
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    type: TypeOption,
    patientSelection: PatientSelection,
    selectedRecipientId: number,
    donorDetails: INewDonorRecipientBaseData,
    donorDetailsValidation: IBaseDataValidation,
    recipientDetails: INewDonorRecipientBaseData,
    recipientDetailsValidation: IBaseDataValidation,
    addPairedDonorOnly: boolean,
    recipientHasCheekSwabResults: boolean,
    genderList: IListItem[],
    bloodTypeList: IListItem[],
    stateList: IListItem[],
    activePatientList: IRecipient[],
    dirty: boolean,
    createMicrosite: boolean
}

class DonorAdd extends Component<TProps, IState> {
    readonly state: IState = {
        type: TypeOption.Select,
        patientSelection: PatientSelection.NewPatient,
        selectedRecipientId: 0,
        donorDetails: initialDonorDetails,
        donorDetailsValidation: initialValidation,
        recipientDetails: initialRecipientDetails,
        recipientDetailsValidation: initialValidation,
        addPairedDonorOnly: false,
        recipientHasCheekSwabResults: false,
        genderList: [],
        bloodTypeList: [],
        stateList: [],
        activePatientList: [],
        dirty: false,
        createMicrosite: false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let parsed = qs.parse(window.location.search);
        let recipientId = parsed.recipientId != null ? parseInt(parsed.recipientId) : 0;

        this.props.showLoading('Getting setup data, one moment please...').then(() => {
            this.props.getLookupData(this.props.centerId)
                .then(response => {
                    if (response.data.success) {
                        let { genderList, bloodTypeList, stateList, activePatientList } = response.data.results;

                        this.setState({
                            genderList,
                            bloodTypeList,
                            stateList,
                            activePatientList
                        }, () => {

                            if (recipientId > 0) {
                                this.setState({
                                    type: TypeOption.PairPd,
                                    patientSelection: PatientSelection.ExistingPatient,
                                    addPairedDonorOnly: true
                                });

                                this.handleSelectPatient([recipientId]);
                            }
                        });
                    }
                })
                .finally(() => {
                    this.props.hideLoading();
                });
        });
    }

    validate = () => {
        let {
            alias: donorAlias, mrn: donorMrn,
            gender: donorGender, dateOfBirth: donorDateOfBirth,
            email: donorEmail, phoneNumber: donorPhoneNumber,
            firstName: donorFirstName, lastName: donorLastName,
            bloodType: donorBloodType,
            hasNutcracker: donorHasNutcracker,
            address: donorAddress, city: donorCity, state: donorState, postalCode: donorPostalCode,
            existingAlias: donorExistingAlias, existingMrn: donorExistingMrn,
            shipTypingSwabs: donorShipTypingSwabs,
            medicalRecord: donorMedicalRecord } = this.state.donorDetailsValidation;

        let donorValid = true;

        if (this.state.type != TypeOption.PatientOnly) {
            donorValid = donorAlias && donorMrn
                && donorGender && donorDateOfBirth
                && donorEmail && donorPhoneNumber
                && donorFirstName && donorLastName
                && donorBloodType
                && donorHasNutcracker
                && donorAddress && donorCity && donorState && donorPostalCode
                && donorExistingAlias == false && donorExistingMrn == false
                && donorShipTypingSwabs
                && donorMedicalRecord;
        }

        let {
            alias: recipientAlias, mrn: recipientMrn,
            gender: recipientGender, dateOfBirth: recipientDateOfBirth,
            email: recipientEmail, phoneNumber: recipientPhoneNumber,
            firstName: recipientFirstName, lastName: recipientLastName,
            bloodType: recipientBloodType,
            address: recipientAddress, city: recipientCity, state: recipientState, postalCode: recipientPostalCode,
            existingAlias: recipientExistingAlias, existingMrn: recipientExistingMrn,
            shipTypingSwabs: recipientShipTypingSwabs,
            medicalRecord: recipientMedicalRecord } = this.state.recipientDetailsValidation;

        let recipientValid = true;

        if (this.state.type >= TypeOption.PairSv) {
            if (this.state.patientSelection == PatientSelection.NewPatient) {
                recipientValid =
                    recipientAlias && recipientMrn
                    && recipientGender && recipientDateOfBirth
                    && recipientEmail && recipientPhoneNumber
                    && recipientFirstName && recipientLastName
                    && recipientBloodType
                    && recipientAddress && recipientCity && recipientState && recipientPostalCode
                    && recipientExistingAlias == false && recipientExistingMrn == false
                    && recipientShipTypingSwabs
                    && recipientMedicalRecord;
            } else {
                if (this.state.selectedRecipientId == 0) {
                    recipientValid = false;
                } else if (!recipientShipTypingSwabs) {
                    recipientValid = false;
                }
            }
        }

        return { donorValid, recipientValid };
    }

    handleTypeChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            type: parseInt(e.currentTarget.value),
            patientSelection: PatientSelection.NewPatient,
            donorDetails: initialDonorDetails,
            donorDetailsValidation: initialValidation,
            recipientDetails: initialRecipientDetails,
            recipientDetailsValidation: initialValidation,
            recipientHasCheekSwabResults: false
        });
    }

    handlePatientSelectionChange = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            patientSelection: parseInt(e.currentTarget.value),
            selectedRecipientId: 0,
            recipientHasCheekSwabResults: false,
            recipientDetails: initialRecipientDetails,
            recipientDetailsValidation: initialValidation
        });
    }

    handleDonorDetailsFieldChange = (name: string, value: any) => {
        let donorDetails = _.cloneDeep(this.state.donorDetails);
        donorDetails[name] = value;

        this.setState({
            donorDetails
        });
    }

    handleRecipientDetailsFieldChange = (name: string, value: any) => {
        let recipientDetails = _.cloneDeep(this.state.recipientDetails);
        recipientDetails[name] = value;

        this.setState({
            recipientDetails
        });
    }

    handleSelectPatient = (list: number[]) => {
        let selectedRecipientId = list.length > 0 ? list[0] : 0;
        let recipientDetails = _.cloneDeep(this.state.recipientDetails);

        let recipient = this.state.activePatientList.find(x => x.id == selectedRecipientId);

        if (recipient != null) {
            recipientDetails = {
                alias: recipient.alias,
                mrn: recipient.mrn,
                gender: recipient.gender,
                dateOfBirth: recipient.birthDate,
                email: recipient.email,
                phoneNumber: recipient.phoneNumber,
                firstName: recipient.firstName,
                lastName: recipient.lastName,
                bloodType: recipient.bloodType,
                hasNutcracker: null,
                address: recipient.phiAddress,
                city: recipient.phiCity,
                state: recipient.phiState,
                postalCode: recipient.phiPostalCode,
                shipTypingSwabs: -1,
                sendSelfRegistrationInvite: -1,
                medicalRecordId: 0
            };
        } else {
            recipientDetails = initialRecipientDetails;
        }

        this.setState({
            selectedRecipientId,
            recipientDetails,
            recipientHasCheekSwabResults: recipient?.hasCheekSwabResults ?? false
        });
    }

    validatePhoneNumber = (value) => {
        // Basic US phone number format: (123) 456-7890 or 123-456-7890
        const phoneRegex = /^(\+1|1)?[-.\s]?\(?[2-9]\d{2}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
        return phoneRegex.test(value);
    }

    saveNewDonorRecipient = (type: number, selectedRecipientId: number, donorDetails: INewDonorRecipientBaseData, recipientDetails: INewDonorRecipientBaseData) => {
        this.props.showLoading('Saving, one moment please...').then(() => {
            this.props.saveNewDonorRecipient(this.props.centerId, type, selectedRecipientId, donorDetails, recipientDetails)
                .then(response => {
                    if (response.data.success) {
                        let { donorId, recipientId, messages } = response.data.results;

                        let message = '';
                        let redirect = '';
                        let hasSwabNotice = (messages ?? []).length > 0;

                        (messages ?? []).forEach(swabMessage => toast.warning(swabMessage, { autoClose: 10000 }));

                        if (type >= TypeOption.DonorOnlyNdd && type <= TypeOption.DonorOnlySv) {
                            message = 'Donor created successfully, redirecting to the edit page';
                            redirect = '/center/' + this.props.centerId + '/donor/' + donorId + '/profile';
                        }

                        if (type >= TypeOption.PairSv && type <= TypeOption.PairNkrId) {
                            message = 'Donor/recipient pair created successfully, redirecting to the edit page';
                            redirect = '/center/' + this.props.centerId + '/donor/' + donorId + '/profile';
                        }

                        if (type == TypeOption.PatientOnly) {
                            message = 'Patient created successfully, redirecting to the edit page';
                            redirect = '/center/' + this.props.centerId + '/recipient/' + recipientId + '/profile/general';
                        }

                        const buildCheekSwabRequest = (details: INewDonorRecipientBaseData): ICheekSwabRequest => ({
                            firstName: details.firstName,
                            lastName: details.lastName,
                            address1: details.address,
                            address2: '',
                            city: details.city,
                            state: details.state,
                            postalCode: details.postalCode,
                            contactPhone: details.phoneNumber,
                            email: details.email,
                            dob: details.dateOfBirth
                        });

                        const bulkCalls: Promise<void>[] = [];

                        if (donorId > 0 && donorDetails.shipTypingSwabs === 2) {
                            const bulkCall = this.props.createDonorOrder(donorId, buildCheekSwabRequest(donorDetails))
                                .then(resp => {
                                    const fileName = donorDetails.firstName + '_' + donorDetails.lastName + '_CheekSwab';
                                    downloadFile(resp.data, fileName, resp.data.type);
                                })
                                .catch(async error => {
                                    hasSwabNotice = true;
                                    toast.warning(error?.response?.data instanceof Blob ? await error.response.data.text() : 'Could not generate donor cheek swab requisition.', { autoClose: 10000 });
                                });
                            bulkCalls.push(bulkCall);
                        }

                        if (recipientId > 0 && recipientDetails.shipTypingSwabs === 2) {
                            const bulkCall = this.props.createRecipientOrder(recipientId, buildCheekSwabRequest(recipientDetails))
                                .then(resp => {
                                    const fileName = recipientDetails.firstName + '_' + recipientDetails.lastName + '_CheekSwab';
                                    downloadFile(resp.data, fileName, resp.data.type);
                                })
                                .catch(async error => {
                                    hasSwabNotice = true;
                                    toast.warning(error?.response?.data instanceof Blob ? await error.response.data.text() : 'Could not generate recipient cheek swab requisition.', { autoClose: 10000 });
                                });
                            bulkCalls.push(bulkCall);
                        }

                        Promise.all(bulkCalls).finally(() => {
                            toast.success(message, {
                                autoClose: hasSwabNotice ? 10000 : undefined,
                                onClose: () => {
                                    window.location.href = redirect;
                                },
                            });

                            this.props.hideLoading();
                        });
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data ?? 'An error occurred while saving');
                    this.props.hideLoading();
                });
        });
    }

    saveNewPairedDonor = (selectedRecipientId: number, donorDetails: INewDonorRecipientBaseData) => {
        this.props.showLoading('Saving, one moment please...').then(() => {
            this.props.saveNewPairedDonor(this.props.centerId, selectedRecipientId, donorDetails)
                .then(response => {
                    if (response.data.success) {
                        let { recipientId, messages } = response.data.results;

                        (messages ?? []).forEach(swabMessage => toast.warning(swabMessage, { autoClose: 10000 }));

                        toast.success('Donor created successfully, redirecting to the patient profile', {
                            autoClose: (messages ?? []).length > 0 ? 10000 : undefined,
                            onClose: () => {
                                window.location.href = '/center/' + this.props.centerId + '/recipient/' + recipientId + '/profile/paired-donors';
                            },
                        });

                        this.props.hideLoading();
                    }
                })
                .catch(error => {
                    toast.error(error?.response?.data ?? 'An error occurred while saving');
                    this.props.hideLoading();
                });
        });
    }

    handleSave = async () => {
        let { type, selectedRecipientId, donorDetails, recipientDetails } = this.state;
        let { alias: donorAlias, mrn: donorMrn } = donorDetails;
        let { alias: recipientAlias, mrn: recipientMrn } = recipientDetails;

        let donorExistingAlias: IExistingMatch[] = [];
        let donorExistingMrn: IExistingMatch[] = [];

        let recipientExistingAlias: IExistingMatch[] = [];
        let recipientExistingMrn: IExistingMatch[] = [];

        if (donorAlias != '' && donorMrn != '') {
            let donorResponse = await this.props.checkForExistingDonorAliasAndMrn(this.props.centerId, donorAlias, donorMrn);

            donorExistingAlias = donorResponse.data.results.filter(x => x.aliasMatch);
            donorExistingMrn = donorResponse.data.results.filter(x => x.mrnMatch);
        }

        if (recipientAlias != '' && recipientMrn != '') {
            let recipientResponse = await this.props.checkForExistingRecipientAliasAndMrn(this.props.centerId, recipientAlias, recipientMrn);

            recipientExistingAlias = recipientResponse.data.results.filter(x => x.aliasMatch);
            recipientExistingMrn = recipientResponse.data.results.filter(x => x.mrnMatch);
        }

        let regex = new RegExp('^[a-zA-Z0-9]{6,12}$');
        let donorBirthDate = moment(donorDetails.dateOfBirth, 'MM/DD/YYYY', true);
        let donorAge = moment().diff(donorBirthDate, 'years');

        let donorDetailsValidation: IBaseDataValidation = {
            alias: regex.test(donorAlias),
            mrn: donorMrn != '',
            gender: donorDetails.gender != '',
            dateOfBirth: donorBirthDate.isValid() && donorAge >= 18 && donorAge <= 100,
            bloodType: donorDetails.bloodType != '',
            hasNutcracker: donorDetails.hasNutcracker != null,
            email: donorDetails.email != '',
            phoneNumber: this.validatePhoneNumber(donorDetails.phoneNumber),
            firstName: donorDetails.firstName != '',
            lastName: donorDetails.lastName != '',
            address: donorDetails.address != '',
            city: donorDetails.city != '',
            state: donorDetails.state != '',
            postalCode: donorDetails.postalCode != '',
            existingAlias: donorExistingAlias.length > 0,
            existingMrn: donorExistingMrn.length > 0,
            shipTypingSwabs: donorDetails.shipTypingSwabs !== -1,
            medicalRecord: donorDetails.medicalRecordId !== 0
        };

        let recipientDetailsValidation: IBaseDataValidation = {
            alias: recipientAlias != '',
            mrn: recipientMrn != '',
            gender: recipientDetails.gender != '',
            dateOfBirth: moment(recipientDetails.dateOfBirth, 'MM/DD/YYYY').isValid(),
            bloodType: recipientDetails.bloodType != '',
            hasNutcracker: true, //doesn't exist for recipients
            email: recipientDetails.email != '',
            phoneNumber: this.validatePhoneNumber(recipientDetails.phoneNumber),
            firstName: recipientDetails.firstName != '',
            lastName: recipientDetails.lastName != '',
            address: recipientDetails.address != '',
            city: recipientDetails.city != '',
            state: recipientDetails.state != '',
            postalCode: recipientDetails.postalCode != '',
            existingAlias: selectedRecipientId == 0 && recipientExistingAlias.length > 0,
            existingMrn: selectedRecipientId == 0 && recipientExistingMrn.length > 0,
            shipTypingSwabs: recipientDetails.shipTypingSwabs !== -1 || this.state.recipientHasCheekSwabResults,
            medicalRecord: selectedRecipientId > 0 || recipientDetails.medicalRecordId !== 0
        };

        this.setState({
            donorDetailsValidation,
            recipientDetailsValidation,
            dirty: true
        }, () => {
            let { donorValid, recipientValid } = this.validate();

            if (donorValid && recipientValid) {
                if (this.state.addPairedDonorOnly == false) {
                    this.saveNewDonorRecipient(type, selectedRecipientId, donorDetails, recipientDetails);
                } else {
                    this.saveNewPairedDonor(selectedRecipientId, donorDetails);
                }
            }
        });
    }

    handleCreateMicrositeCheck = () => {
        this.setState({
            createMicrosite: !this.state.createMicrosite
        })
    }

    render = () => {
        const { donorValid, recipientValid } = this.validate();
        const showNewExistingToggle = this.state.type >= TypeOption.PairSv && this.state.type <= TypeOption.PairNkrId;
        const showPatientDetails = this.state.type >= TypeOption.PairSv && this.state.type <= TypeOption.PatientOnly;

        return (
            <ContainerWrapper className='container-fluid'>
                {this.state.dirty && (!donorValid || !recipientValid) && (
                    <Alert bsStyle='danger'>
                        <p>Please resolve the following issues to continue...</p>

                        <ul>
                            {!donorValid && (
                                <li>Donor Details - the items in red are required to continue...</li>
                            )}

                            {!recipientValid && this.state.patientSelection == PatientSelection.NewPatient && (
                                <li>Recipient Details - the items in red are required to continue...</li>
                            )}

                            {!recipientValid && this.state.patientSelection == PatientSelection.ExistingPatient && this.state.selectedRecipientId == 0 && (
                                <li>Recipient Details - you must select an existing patient...</li>
                            )}
                        </ul>
                    </Alert>
                )}

                <h2 style={{ marginTop: 0, marginBottom: 20 }}>{this.state.addPairedDonorOnly == false ? 'Add Donor, Pair, or Recipient' : 'Add Paired Donor'}</h2>

                {this.state.addPairedDonorOnly == false && (
                    <Form inline style={{ marginBottom: 20 }}>
                        <FormGroup style={{ marginRight: 20 }}>
                            <ControlLabel style={{ paddingRight: 10 }}>Add:</ControlLabel>
                            <FormControl
                                componentClass='select'
                                value={this.state.type}
                                onChange={this.handleTypeChange}
                            >
                                <option value={0}>- Please Select -</option>
                                {typeOptionList.map(item =>
                                    <option value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </FormGroup>

                        {showNewExistingToggle &&
                            <FormGroup>
                                <ControlLabel style={{ paddingRight: 10 }}>Type of Recipient:</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.patientSelection}
                                    onChange={this.handlePatientSelectionChange}
                                >
                                    <option value={1}>New</option>
                                    <option value={2}>Existing</option>
                                </FormControl>
                            </FormGroup>
                        }
                    </Form>
                )}

                <Row>
                    {this.state.type != TypeOption.Select && this.state.type != TypeOption.PatientOnly && (
                        <Col xs={12} lg={6}>
                            <Panel>
                                <Panel.Heading>New Donor Details</Panel.Heading>
                                <Panel.Body>
                                    <DonorDetails
                                        centerId={this.props.centerId}
                                        type={this.state.type}
                                        data={this.state.donorDetails}
                                        validation={this.state.donorDetailsValidation}
                                        genderList={this.state.genderList}
                                        bloodTypeList={this.state.bloodTypeList}
                                        stateList={this.state.stateList}
                                        onFieldChange={this.handleDonorDetailsFieldChange}
                                    />
                                </Panel.Body>
                            </Panel>
                        </Col>
                    )}
                    <Col xs={12} lg={6}>
                        {showPatientDetails &&
                            <Panel>
                                <Panel.Heading>{this.state.patientSelection == 1 ? 'New' : 'Existing'} Recipient Details</Panel.Heading>
                                <Panel.Body>
                                    {this.state.patientSelection == PatientSelection.NewPatient ?
                                        <RecipientDetails
                                            centerId={this.props.centerId}
                                            data={this.state.recipientDetails}
                                            validation={this.state.recipientDetailsValidation}
                                            newPatient={true}
                                            selectedRecipientId={this.state.selectedRecipientId}
                                            addPairedDonorOnly={this.state.addPairedDonorOnly}
                                            recipientHasCheekSwabResults={this.state.recipientHasCheekSwabResults}
                                            recipientList={this.state.activePatientList}
                                            genderList={this.state.genderList}
                                            bloodTypeList={this.state.bloodTypeList}
                                            stateList={this.state.stateList}
                                            onFieldChange={this.handleRecipientDetailsFieldChange}
                                            onRecipientSelect={this.handleSelectPatient}
                                        />
                                        :
                                        <RecipientDetails
                                            centerId={this.props.centerId}
                                            data={this.state.recipientDetails}
                                            validation={this.state.recipientDetailsValidation}
                                            newPatient={false}
                                            selectedRecipientId={this.state.selectedRecipientId}
                                            addPairedDonorOnly={this.state.addPairedDonorOnly}
                                            recipientHasCheekSwabResults={this.state.recipientHasCheekSwabResults}
                                            recipientList={this.state.activePatientList}
                                            genderList={this.state.genderList}
                                            bloodTypeList={this.state.bloodTypeList}
                                            stateList={this.state.stateList}
                                            onFieldChange={this.handleRecipientDetailsFieldChange}
                                            onRecipientSelect={this.handleSelectPatient}
                                        />
                                    }
                                </Panel.Body>
                            </Panel>
                        }
                    </Col>
                </Row>

                {this.state.type != TypeOption.Select && (
                    <>
                        {showPatientDetails && this.state.type != TypeOption.PatientOnly ?
                            <Row>
                                <Col xs={12} lg={4} lgOffset={4}>
                                    <Button bsStyle='primary' bsSize='lg' block onClick={this.handleSave}>Save</Button>
                                </Col>
                            </Row>
                            :
                            <Row>
                                <Col xs={12} lg={6}>
                                    <Button bsStyle='primary' bsSize='lg' block onClick={this.handleSave}>Save</Button>
                                </Col>
                            </Row>
                        }
                    </>
                )}
            </ContainerWrapper>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {};
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getLookupData: (centerId) => {
            return dispatch(NewDonorRecipientActionCreators.getNewDonorRecipientLookupData(centerId));
        },
        checkForExistingDonorAliasAndMrn: (centerId, alias, mrn) => {
            return dispatch(NewDonorRecipientActionCreators.checkForExistingDonorAliasAndMrn(centerId, alias, mrn));
        },
        checkForExistingRecipientAliasAndMrn: (centerId, alias, mrn) => {
            return dispatch(NewDonorRecipientActionCreators.checkForExistingRecipientAliasAndMrn(centerId, alias, mrn));
        },
        saveNewDonorRecipient: (centerId, type, existingRecipientId, donorDetails, recipientDetails) => {
            return dispatch(NewDonorRecipientActionCreators.saveNewDonorRecipient(centerId, type, existingRecipientId, donorDetails, recipientDetails));
        },
        saveNewPairedDonor: (centerId, existingRecipientId, donorDetails) => {
            return dispatch(NewDonorRecipientActionCreators.saveNewPairedDonor(centerId, existingRecipientId, donorDetails));
        },
        createDonorOrder: (donorId, request) => {
            return dispatch(OrdersActionCreators.createDonorOrder(donorId, request));
        },
        createRecipientOrder: (recipientId, request) => {
            return dispatch(OrdersActionCreators.createRecipientOrder(recipientId, request));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(DonorAdd);